import { Grid, TextField } from "@mui/material";
import * as React from "react";
import { IIdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { EventTypeCategory } from "ui/Scripts/source/models/enums";
import { Translations } from "ui/Scripts/source/models/translations";
import { IEventEditItem } from "source/models/event/eventEditItem";
import { DialogSectionCard } from "source/components/framework/Dialog/DialogSectionCard";
import { FormField } from "ui/Scripts/source/components/framework/FormField";
import { GridRow } from "source/components/framework/Grid/GridRow";
import { EventEditDialogIdentificationEventTypeList } from "./EventEditDialogIdentificationEventTypeList";

export interface IEventEditDialogIdentificationProp {
    screenHeight: number;
    companyId: string;
    event: IEventEditItem;
    isClosed: boolean;
    isLockedToOtherUser: boolean;
    canEditIdentificationData: boolean;
    eventTypeNodes: IIdTitleNode[];
    eventTypeBNodes: IIdTitleNode[];
    eventTypeCNodes: IIdTitleNode[];
    //Identification
    eventTypeIds: string[];
    eventTypeBIds: string[];
    eventTypeCIds: string[];
    identificationDetails: string;
    directCostsStr: string;
    indirectCostsStr: string;
    amountStr: string;
    onChange: (name: string, value: string) => void;
    onBlur: (name: string, value: string) => void;
    onChangeEventTypeIds: (ids: string[]) => void;
    onChangeEventTypeBIds: (ids: string[]) => void;
    onChangeEventTypeCIds: (ids: string[]) => void;
}

const numRegex = /^(?:\d+(?:,\d+)*,?)?$/;

export const EventEditDialogIdentification = (props: IEventEditDialogIdentificationProp) => {
    const handleChange = (event) => {
        const target = event.target;
        if (target.name !== "identificationDetails" && !numRegex.test(target.value)) return;
        props.onChange(target.name, target.value);
    };

    const handleBlur = (event) => {
        const target = event.target;
        props.onBlur(target.name, target.value);
    };

    const isPublished = props.event.isPublished();
    const eventTypesAreEditable = !isPublished || props.canEditIdentificationData;
    const identificationDataIsEditable = !props.isLockedToOtherUser && eventTypesAreEditable;
    const hasEventTypeBs = props.eventTypeBNodes.length > 0;
    const hasEventTypeCs = props.eventTypeCNodes.length > 0;
    const eventTypeColWidth = hasEventTypeBs && hasEventTypeCs
        ? 4
        : (hasEventTypeBs || hasEventTypeCs
            ? 6
            : 12);

    if (!props.event) return null;
    
    return (
        <>
            <GridRow flexGrow={0}>
                <Grid item sm={12} md={eventTypeColWidth}>
                    <EventEditDialogIdentificationEventTypeList
                        isReadOnly={!eventTypesAreEditable}
                        screenHeight={props.screenHeight}
                        companyId={props.companyId}
                        eventId={props.event.id}
                        eventTypeCategory={EventTypeCategory.A}
                        eventTypes={props.eventTypeNodes}
                        eventTypeIds={props.eventTypeIds}
                        onChange={props.onChangeEventTypeIds}
                    />
                </Grid>
                {hasEventTypeBs &&
                    <Grid item sm={12} md={eventTypeColWidth}>
                        <EventEditDialogIdentificationEventTypeList
                            isReadOnly={!eventTypesAreEditable}
                            screenHeight={props.screenHeight}
                            companyId={props.companyId}
                            eventId={props.event.id}
                            eventTypeCategory={EventTypeCategory.B}
                            eventTypes={props.eventTypeBNodes}
                            eventTypeIds={props.eventTypeBIds}
                            onChange={props.onChangeEventTypeBIds}
                        />
                    </Grid>
                }
                {hasEventTypeCs &&
                    <Grid item sm={12} md={eventTypeColWidth}>
                        <EventEditDialogIdentificationEventTypeList
                            isReadOnly={!eventTypesAreEditable}
                            screenHeight={props.screenHeight}
                            companyId={props.companyId}
                            eventId={props.event.id}
                            eventTypeCategory={EventTypeCategory.C}
                            eventTypes={props.eventTypeCNodes}
                            eventTypeIds={props.eventTypeCIds}
                            onChange={props.onChangeEventTypeCIds}
                        />
                    </Grid>
                }
            </GridRow>
            {props.canEditIdentificationData &&
                <GridRow>
                    <Grid item sm={12}>
                        <DialogSectionCard headerTitle={Translations.AdditionalInformation} margin="1rem 0 0">
                            <GridRow flexGrow={0}>
                                <Grid item sm={12} md={2}>
                                    <FormField title={Translations.DirectCosts} margin={0}>
                                        <TextField type="text" name="directCosts" title={Translations.DirectCosts} inputProps={{ maxLength: 10 }} value={props.directCostsStr} onChange={handleChange} onBlur={handleBlur} disabled={!identificationDataIsEditable} />
                                    </FormField>
                                </Grid>
                                <Grid item sm={12} md={2}>
                                    <FormField title={Translations.IndirectCosts} margin={0}>
                                        <TextField type="text" name="indirectCosts" title={Translations.IndirectCosts} inputProps={{ maxLength: 10 }} value={props.indirectCostsStr} onChange={handleChange} onBlur={handleBlur} disabled={!identificationDataIsEditable} />
                                    </FormField>
                                </Grid>
                                <Grid item sm={12} md={2}>
                                    <FormField title={Translations.Amount} margin={0}>
                                        <TextField type="text" name="amount" title={Translations.Amount} inputProps={{ maxLength: 10 }} value={props.amountStr} onChange={handleChange} onBlur={handleBlur} disabled={!identificationDataIsEditable} />
                                    </FormField>
                                </Grid>
                            </GridRow>
                            <GridRow flexGrow={0}>
                                <Grid item sm={12}>
                                    <FormField title={Translations.IdentificationDetails} margin="1.5rem 0 -16px 0">
                                        <TextField name="identificationDetails" title={Translations.IdentificationDetails} inputProps={{ maxLength: 1000 }} multiline minRows={props.screenHeight === 0 ? 4 : (props.screenHeight === 1 ? 2 : 1)} value={props.identificationDetails} onChange={handleChange} disabled={!identificationDataIsEditable} />
                                    </FormField>
                                </Grid>
                            </GridRow>
                        </DialogSectionCard>
                    </Grid>
                </GridRow>
            }
        </>
    );
};